import styled from 'styled-components';
import { SearchInput } from '../../../../CommonComponents/commonStyles';

export const SearchBar = styled(SearchInput).attrs(() => ({
  id: 'search_element',
}))``;
